<template>
  <article class="message is-warning mt-3" v-if="isActive">
    <div class="message-header">
      <p>{{ title }}</p>
      <button
        v-if="this.delete"
        @click="dontShowThis"
        class="delete"
        aria-label="delete"
      ></button>
    </div>
    <div class="message-body">
      {{ msg }}
    </div>
  </article>
</template>

<script>
export default {
  name: "ShowError",
  props: {
    title: String,
    msg: String,
    delete: Boolean,
    isActive: Boolean,
  },
  methods: {
    dontShowThis() {
      this.isActive = false;
    },
  },
};
</script>
